import { render, staticRenderFns } from "./AntiFraud.vue?vue&type=template&id=76156b9a&scoped=true"
import script from "./AntiFraud.vue?vue&type=script&lang=js"
export * from "./AntiFraud.vue?vue&type=script&lang=js"
import style0 from "./AntiFraud.vue?vue&type=style&index=0&id=76156b9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76156b9a",
  null
  
)

export default component.exports